export const API_BASE_URL = "http://apihoso.khcnhungyen.gov.vn/"
//export const API_BASE_URL = "http://103.176.178.140:61029/"
// export const API_BASE_URL = "http://localhost:61029/"
export const DEFAULT_PASSWORD = "khcn@123"